import Storage from "@/utils/storage";
import { normalizeUserCoupon } from "@/components/Pages/Activity/Voucher/normalizeUserCoupon";

function getLocalDateKey(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** 仅保留当前用户一条：{ userId, neverShow?, lastShownDate? } */
function readPromptRecord() {
  if (typeof window === "undefined") return null;
  const raw = Storage.get("unusedCouponHomePrompt");
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
  return raw;
}

function writePromptRecord(userId, patch) {
  if (userId == null || userId === "") return;
  const uid = String(userId);
  const prev = readPromptRecord();
  const base = prev?.userId === uid ? prev : { userId: uid };
  Storage.set("unusedCouponHomePrompt", {
    userId: uid,
    neverShow: patch.neverShow !== undefined ? !!patch.neverShow : !!base.neverShow,
    lastShownDate: patch.lastShownDate !== undefined ? patch.lastShownDate : base.lastShownDate,
  });
}

function getCurrentUserRecord(userId) {
  if (userId == null || userId === "") return {};
  const row = readPromptRecord();
  if (!row || String(row.userId) !== String(userId)) return {};
  return row;
}

export function isUnusedCouponHomePromptDismissed(userId) {
  if (userId == null || userId === "") return true;
  return !!getCurrentUserRecord(userId).neverShow;
}

export function wasUnusedCouponHomePromptShownToday(userId) {
  if (userId == null || userId === "") return true;
  return getCurrentUserRecord(userId).lastShownDate === getLocalDateKey();
}

export function shouldShowUnusedCouponHomePrompt(userId) {
  if (userId == null || userId === "") return false;
  if (isUnusedCouponHomePromptDismissed(userId)) return false;
  if (wasUnusedCouponHomePromptShownToday(userId)) return false;
  return true;
}

export function markUnusedCouponHomePromptShownToday(userId) {
  if (userId == null || userId === "") return;
  writePromptRecord(userId, { lastShownDate: getLocalDateKey() });
}

export function dismissUnusedCouponHomePromptForever(userId) {
  if (userId == null || userId === "") return;
  writePromptRecord(userId, { neverShow: true, lastShownDate: getLocalDateKey() });
}

export function pickUnusedCouponSummaryItem(items) {
  if (!Array.isArray(items) || items.length === 0) return null;
  const sorted = [...items].sort((a, b) => {
    const ta = Date.parse(a?.grantedAt || a?.effectiveAt || 0) || 0;
    const tb = Date.parse(b?.grantedAt || b?.effectiveAt || 0) || 0;
    return tb - ta;
  });
  return sorted[0] ?? null;
}

export function normalizeUnusedCouponSummaryItem(item) {
  if (!item || typeof item !== "object") return null;
  const id = item.userCouponId ?? item.user_coupon_id ?? item.id;
  return normalizeUserCoupon({
    ...item,
    id,
    status: item.status || "AVAILABLE",
  });
}

export function hasUnusedCouponsFromUserInfo(userInfo) {
  const summary = userInfo?.unusedCouponSummary;
  if (!summary || typeof summary !== "object") return false;
  if (summary.hasUnusedCoupon === true) return true;
  const count = Number(summary.count);
  if (Number.isFinite(count) && count > 0) return true;
  return Array.isArray(summary.items) && summary.items.length > 0;
}
